module.exports = "https://cdn-challenge.mathletics.com/app/282/assets/images/e20eca2c983a31b66b8b865775c42dd7.svg";